import { keycardsRouteStore } from '../domain/store';
import { keycardUpsertModalRouteStore } from '../components/keycard-upsert-modal/domain/store';

export default () => {
  keycardUpsertModalRouteStore.setInitialState();
  keycardsRouteStore.setValue('activeKeycardId', null);
  keycardsRouteStore.setValue('showingKeycardUpsertModal', false);
  keycardsRouteStore.setValue('emailSent', false);
};
